import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { FilterCategory } from "../types";

/**
 * Notification slice — filter UI state only.
 * Server data lives in React Query (useNotifications).
 */
export interface NotificationState {
  activeFilter: FilterCategory;
  selectedStages: string[];
  selectedStatuses: string[];
  selectedSubStatuses: string[];
}

const initialState: NotificationState = {
  activeFilter: "all",
  selectedStages: [],
  selectedStatuses: [],
  selectedSubStatuses: [],
};

const notificationSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    setActiveFilter(state, action: PayloadAction<FilterCategory>) {
      state.activeFilter = action.payload;
      if (action.payload !== "stage") state.selectedStages = [];
      if (action.payload !== "status") state.selectedStatuses = [];
      if (action.payload !== "sub_status") state.selectedSubStatuses = [];
    },
    toggleStageFilter(state, action: PayloadAction<string>) {
      const idx = state.selectedStages.indexOf(action.payload);
      if (idx > -1) state.selectedStages.splice(idx, 1);
      else state.selectedStages.push(action.payload);
    },
    toggleStatusFilter(state, action: PayloadAction<string>) {
      const idx = state.selectedStatuses.indexOf(action.payload);
      if (idx > -1) state.selectedStatuses.splice(idx, 1);
      else state.selectedStatuses.push(action.payload);
    },
    toggleSubStatusFilter(state, action: PayloadAction<string>) {
      const idx = state.selectedSubStatuses.indexOf(action.payload);
      if (idx > -1) state.selectedSubStatuses.splice(idx, 1);
      else state.selectedSubStatuses.push(action.payload);
    },
    clearStageSelections(state) {
      state.selectedStages = [];
    },
    clearStatusSelections(state) {
      state.selectedStatuses = [];
    },
    clearSubStatusSelections(state) {
      state.selectedSubStatuses = [];
    },
  },
});

export const {
  setActiveFilter,
  toggleStageFilter,
  toggleStatusFilter,
  toggleSubStatusFilter,
  clearStageSelections,
  clearStatusSelections,
  clearSubStatusSelections,
} = notificationSlice.actions;

export default notificationSlice.reducer;
